import { uid } from "uid";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import camera from "../../assets/images/profile/ico_camera.svg";
import avatar from "../../assets/images/profile/img_placeholder.svg";
import { getPictureUrl, putUploadAvatar, successUploadAvatar } from "../../store/middleware";

const PhotoAvatar = ({ userID, picture, setPicture }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleUploadFile = async (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];

      if (file.size / 1024 / 1024 > 2) {
        alert("The max filesize is 2MB");
        return;
      }

      if (file) {
        const newFileName = uid(25).concat(file.type).replace("/", ".");
        const awsUrl = await dispatch(getPictureUrl(userID, newFileName));

        const reader = new FileReader();
        reader.onload = async (event) => {
          await dispatch(putUploadAvatar(awsUrl, event.target.result, file.type)).then((resp) => {
            if (resp.status === 200) {
              dispatch(successUploadAvatar(userID, newFileName)).then((resp) => setPicture(resp));
            }
          });
        };

        reader.readAsArrayBuffer(file);
      }
    }
  };

  return (
    <div className="changePhoto">
      <h2>{t("PHOTO")}</h2>
      <form>
        <div className="photo">
          <img
            alt="Avatar"
            width="112"
            height="112"
            className="avatarRound"
            src={picture ? picture : avatar}
            style={{ borderRadius: "50%", objectFit: "cover" }}
          />
          <div className="fileUpload btn btn-primary">
            <span>
              <img src={camera} alt="Camera" width="16" height="14" />
              {t("CHANCE_PICTURE")}
            </span>
            <input
              type="file"
              id="uploadBtn"
              className="upload"
              onChange={handleUploadFile}
              accept="image/png, image/jpg, image/jpeg"
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default PhotoAvatar;
